import { createContext, useMemo, useState } from 'react';

export const ProgressContext = createContext({
    isLoading: false,
    setIsLoading: (isLoading: boolean) => { },
});

export const ProgressProvider = (props: any) => {
    const [isLoading, setIsLoading] = useState(false);

    const values = useMemo(
        () => ({ isLoading, setIsLoading }),
        [isLoading]
    );

    return (
        <ProgressContext.Provider value={values}>
            {props.children}
        </ProgressContext.Provider>
    );
};